@if (!loading && products?.length) {
  <div class="grid grid-cols-3 sm:grid-cols-3 md:grid-cols-5 lg:grid-cols-5 xl:grid-cols-8 2xl:grid-cols-10 gap-3">
    @for (p of products; track trackById($index, p)) {
      <a
        class="group border border-base-300 rounded-lg p-3 transition-colors hover:bg-base-200"
        [routerLink]="['/products/', p.id]"
      >
        <!-- image -->
        <div class="aspect-square bg-base-200 rounded-md overflow-hidden">
          <img
            class="h-full w-full object-contain"
            [src]="p.primary_thumb_image?.url || (p.image_thumb_url || 'https://placehold.co/256x256/EEE/31343C?font=noto-sans&text=' + p.name)"
            alt="{{p.name}}"
            loading="lazy"
          />
        </div>

        <!-- text -->
        <div class="mt-3">
          <div class="text-sm font-medium truncate group-hover:text-primary transition-colors">
            {{ p | productName }}
          </div>
          <div class="text-xs text-base-content/60 mt-1 truncate">
            {{ p.quantity_as_text }}
          </div>
        </div>
      </a>
    }
  </div>
}

@if (!loading && (!products || products.length === 0)) {
  <div>
    <p class="text-muted">No out-of-stock products.</p>
  </div>
}

@if (loading) {
  <div>
    <div class="loading-inline d-flex align-items-center">
      <div class="spinner-border me-2" role="status" aria-hidden="true"></div>
      <small>Loading out-of-stock products...</small>
    </div>
  </div>
}

